import * as angular from 'angular';
import {IController, IScope} from "angular";
import * as _ from "lodash";
import {LocationType} from "../../../commons/types/location.type";
import {SplitService} from "../../../commons/services/split-service.service";

// DEPRECATED - TO DELETE
export class DeliveriesMapViewTableRowCtrl implements IController {
  selectedGroup: any;
  groupList: any;
  onChange: Function;

  id: any;
  isSelected: any;
  isExpended: any;
  columns: any;
  toggle: Function;
  onExpand: Function;

  public locationTypes: typeof LocationType = LocationType;
  private service: any;
  private configZoneId: any;

  /* @ngInject */
  constructor(private $delivery, private splitService: SplitService, private $scope: IScope) {
  }

  $onInit() {
    if (this.id) {
      this.$delivery(this.id).$bindCtrlToId(this.$scope, this, 'service', 'id');
      this.configZoneId = this.splitService.getTimeZone();
    }
  }

  $onChanges(changes) {
    if (changes.id && !changes.id.isFirstChange()) {
      this.$onInit();
    }
  };

  checkBoxClick() {
    this.toggle({serviceId: this.id});
  }

  onBeforeExpand() {
    const hasRelations = _.some(this.service.taskList, (t) => {
      return t.relations && t.relations.length;
    });
    if (hasRelations) {
      this.onExpand({serviceId: this.id});
    }
  }

}

angular
  .module('bringoz.admin.deliveries')
  .component('deliveriesMapViewTableRow', {
    require: {
      deliveriesMapViewTableCtrl: '^deliveriesMapViewTable'
    },
    bindings: {
      id: '<',
      isSelected: '<',
      isExpended: '<',
      columns: '<',
      toggle: '&',
      onExpand: '&'
    },
    template: require('./deliveries-map-view-table-row.html').default,
    controller: DeliveriesMapViewTableRowCtrl
  });
